module.exports = function() {
  return new Worker(__webpack_public_path__ + "c1d540dc7996e7ac75fc.worker.js");
};